import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';
import { ColumnFormat } from '@/modules/core/app/constants/data.constants';
import NumeralService from '@/modules/core/app/services/NumeralService';

export class BillingPlanPrice extends BaseModel {
  price?: number;
  recurringPrice?: number;
  isSaasBilling?: boolean;

  constructor(model: Partial<BillingPlanPrice> = {}) {
    super();

    this.price = model.price;
    this.recurringPrice = model.recurringPrice;
    this.isSaasBilling = model.isSaasBilling;
  }

  get formattedPrice(): string {
    if (!this.price) {
      return '-';
    }

    return NumeralService.formatValue(this.price, ColumnFormat.FORMAT_CURRENCY, 0);
  }
}
